import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NSNotFoundPage } from "namirasoft-site-react";
import { NamirasoftSlackSenderServer } from "namirasoft-slack-sender";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { SlackSenderLayout } from "./SlackSenderLayout";
import { SlackSenderRoutes } from "./SlackSenderRoutes";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import ProviderEditPage from "./pages/ProviderEditPage";
import ProviderListPage from "./pages/ProviderListPage";
import ProviderViewPage from "./pages/ProviderViewPage";
import SendPage from "./pages/SendPage";
import SentListPage from "./pages/SentListPage";
import VerifyBotPage from "./pages/VerifyBotPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_SLACK_SENDER}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_SLACK_SENDER = new EnvService("REACT_APP_BASE_URL_SLACK_SENDER", true).getString();

            let slack_sender = new NamirasoftSlackSenderServer(REACT_APP_BASE_URL_SLACK_SENDER, result.account.token_manager, result.notifier.onError);

            let servers = { slack_sender };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={SlackSenderRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={SlackSenderRoutes.ProviderList} element={<ProviderListPage {...result} servers={servers} />} />
                            <Route path={SlackSenderRoutes.ProviderNew} element={<ProviderEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={SlackSenderRoutes.ProviderView(":id")} element={<ProviderViewPage {...result} servers={servers} />} />
                            <Route path={SlackSenderRoutes.ProviderEdit(":id")} element={<ProviderEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={SlackSenderRoutes.ProviderCopy(":id")} element={<ProviderEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={SlackSenderRoutes.Verify(":provider_id")} element={<VerifyBotPage {...result} servers={servers} />} />

                            <Route path={SlackSenderRoutes.Send(null)} element={<SendPage {...result} servers={servers} />} />
                            <Route path={SlackSenderRoutes.Send(":id")} element={<SendPage {...result} servers={servers} />} />

                            <Route path={SlackSenderRoutes.SentList} element={<SentListPage {...result} servers={servers} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={SlackSenderRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <SlackSenderLayout {...props}>
                {props.children}
            </SlackSenderLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: false
            }
        }}
    />
}

export default Router;